var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs__content"},[_c('contract-document-edo-table',{attrs:{"documents":_vm.documentList},on:{"send":function (docId) {
        _vm.currentDocId = docId;
        _vm.currentDocName = _vm.getDocName(docId);
        _vm.showDocSendingDialog = true;
      },"download":function (docId) {
        _vm.currentDocId = docId;
        _vm.currentDocName = _vm.getDocName(docId);
        _vm.showDocDownloadingDialog = true;
      },"accept":function (docId) {
        _vm.currentDocId = docId;
        _vm.currentDocName = _vm.getDocName(docId);
        _vm.currentDocStatus = 0;
        _vm.declineDialogMessage = '';
        _vm.setDocStatus();
      },"decline":function (docId) {
        _vm.currentDocId = docId;
        _vm.currentDocName = _vm.getDocName(docId);
        _vm.currentDocStatus = 1;
        _vm.declineDialogMessage = '';
        _vm.declineDialog = true;
      }}}),_c('contract-doc-getter-dialog',{attrs:{"show-dialog":_vm.showDocSendingDialog,"doc-id":_vm.currentDocId,"doc-name":_vm.currentDocName,"is-send-mode":true,"is-edo-mode":true},on:{"agree":function (ref) {
        var email = ref.payload;

        _vm.closeAllDialogs();
        _vm.targetEmail = email;
        _vm.useDocSendingDialogNotice = !_vm.useDocSendingDialogNotice;
      },"disagree":_vm.closeAllDialogs}}),_c('contract-doc-getter-dialog',{attrs:{"show-dialog":_vm.showDocDownloadingDialog,"doc-id":_vm.currentDocId,"doc-name":_vm.currentDocName,"is-edo-mode":true},on:{"agree":_vm.closeAllDialogs,"disagree":_vm.closeAllDialogs}}),_c('x-dialog',{attrs:{"show":_vm.declineDialog,"agree-button-state":_vm.declineDialogMessage == '',"use-disagree-button-as-icon":true,"agree-button-text":"Подтвердить"},on:{"agree":function () {
      _vm.declineDialog = false;
      _vm.setDocStatus();
    },"disagree":_vm.closeAllDialogs},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Укажите причину отклонения")]},proxy:true},{key:"default",fn:function(){return [_c('v-col',[_c('v-textarea',{attrs:{"no-resize":"","rows":"3","outlined":"","single-line":""},model:{value:(_vm.declineDialogMessage),callback:function ($$v) {_vm.declineDialogMessage=$$v},expression:"declineDialogMessage"}})],1)]},proxy:true}])}),_c('x-notice',{attrs:{"show":_vm.useDocSendingDialogNotice}},[_vm._v(" Документы успешно отправлены на email: "+_vm._s(_vm.targetEmail)+" ")]),_c('x-notice',{attrs:{"show":_vm.showDocSubscribeDialogNotice}},[_vm._v(" Документ успешно "+_vm._s(_vm.currentDocStatus === 0 ? 'принят' : 'отклонен')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }